export function hasPendingAssignTask(detail = {}) {
  return Boolean(detail.assignTaskName)
}

export function buildTaskExecutedField(submitStatus, taskExecuted) {
  if (submitStatus !== 4) {
    return false
  }

  return Boolean(taskExecuted)
}
